export const breakpoints = {
  md: '768px',
  lg: '1024px',
};
